import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { isMobile } from "react-device-detect";
import useStyles from "./styles";

import OPEN_PLAY_COMMUNITY_DATA from "../data";
import OpenPlayCommunityPopup from "../OpenPlayCommunityPopup/index";
import MobileFooter from "../../Footer/MobileFooter";
import DeskFooter from "../../Footer/DeskFooter";

const KM_LOGO =
  "https://km-landing.s3.ap-south-1.amazonaws.com/Images/emailers/km-com-new-logo.png";

const OPEN_PLAY_LOGO =
  "https://km-landing.s3.ap-south-1.amazonaws.com/Images/open-play-wtsp-comm.png";

const WHATSAPP_ICON =
  "https://km-landing.s3.ap-south-1.amazonaws.com/Images/wtsp-comm-icon.png";

export default function OpenPlayCommunityLandingPage() {
  const classes = useStyles();

  const [selectedCity, setSelectedCity] = useState(null);
  const [popupOpen, setPopupOpen] = useState(false);

  const handleCityClick = (city) => {
    setSelectedCity(city);
    setPopupOpen(true);
  };

  const handleClosePopup = () => {
    setPopupOpen(false);
    setSelectedCity(null);
  };

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Join Our Free Open Play Community | KheloMore</title>
        <meta
          name="description"
          content="Join KheloMore’s free Open Play WhatsApp communities across cities like Mumbai, Bengaluru, Pune and Hyderabad. Find players and games for pickleball, badminton, padel, box cricket and more."
        />
        <meta
          name="keywords"
          content="Open Play WhatsApp groups, Open Play community, KheloMore Open Play, pickleball WhatsApp group, badminton WhatsApp group, padel community, box cricket group, tennis community, table tennis group, basketball community, Mumbai, Bengaluru, Hyderabad, Pune, Delhi NCR, Kolkata, Nagpur"
        />
        <link rel="canonical" href={window.location.href} />
        <meta
          property="og:title"
          content="Join Our Free Open Play Community | KheloMore"
        />
        <meta
          property="og:description"
          content="Join KheloMore’s free Open Play WhatsApp communities across cities like Mumbai, Bengaluru, Pune and Hyderabad. Find players and games for pickleball, badminton, padel, box cricket and more."
        />
        <meta property="og:url" content={window.location.href} />
        ----------------OGCard Section -------------------------
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="En" />
      </Helmet>

      <main className={classes.pageContainer}>
        {/* Logos */}
        <header className={classes.logoHeader}>
          <Link to="/" className={classes.kmLogoLink}>
            <img src={KM_LOGO} alt="KheloMore" className={classes.kmLogo} />
          </Link>

          <img
            src={OPEN_PLAY_LOGO}
            alt="Open Play"
            className={classes.openPlayLogo}
          />
        </header>

        {/* Hero content */}
        <section className={classes.heroSection}>
          <h1 className={classes.heroHeading}>
            Join Our Free Open Play Community
          </h1>

          <div className={classes.heroDescription}>
            <p className={classes.tagline}>
              Where players become an insider circle.
            </p>

            <p className={classes.communityStats}>
              10,000+ Members | 300+ Weekly Games Hosted
            </p>
          </div>
        </section>

        {/* City selection */}
        <section className={classes.citySection}>
          <div className={classes.citySelectionCard}>
            <h2 className={classes.chooseCityHeading}>Choose your City</h2>

            <div className={classes.cityGrid}>
              {OPEN_PLAY_COMMUNITY_DATA.map((city) => (
                <button
                  key={city.city}
                  type="button"
                  className={classes.cityCard}
                  onClick={() => handleCityClick(city)}
                  data-openplay-landing-gtm-id="city-select"
                  data-city-name={city.city}
                >
                  <div className={classes.cityImageWrapper}>
                    {city.image ? (
                      <img
                        src={city.image}
                        alt={`${city.city} Open Play Community`}
                        className={classes.cityImage}
                      />
                    ) : (
                      <div className={classes.blankCityImage} />
                    )}

                    <img
                      src={WHATSAPP_ICON}
                      alt="WhatsApp"
                      aria-hidden="true"
                      className={classes.whatsappIcon}
                    />
                  </div>

                  <span className={classes.cityName}>{city.city}</span>
                </button>
              ))}
            </div>
          </div>
        </section>
      </main>

      {isMobile ? (
        <div>
          <MobileFooter />
        </div>
      ) : (
        <div>
          <DeskFooter />
        </div>
      )}

      {/* Reuse the existing popup */}
      <OpenPlayCommunityPopup
        open={popupOpen}
        city={selectedCity}
        onClose={handleClosePopup}
        gtmTrackingId="openplay-landing-group-click"
      />
    </>
  );
}
